import { Dialog } from '@headlessui/react';
import PurchaseButton from '../products/PurchaseButton';
import AddToCart from '../collections/AddToCart';
import { NewExitIcon } from '../../modules/Icons';
import { DividerWithText } from '../../modules/DividerWithText';

import { CollectionResponse } from '../../types/api/CollectionsIndexTypes';

const PermanentPurchaseOptionsModal = ({ isOpen, onClose, collection, setCollection = (collection: CollectionResponse) => {} }) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div
        className="fixed inset-0 flex items-center justify-center bg-black/60 overflow-x-hidden z-[100]"
      >
        <Dialog.Panel className="max-h-[100vh]">
          <div className='bg-gray-800 w-full lg:w-[700px] rounded-[10px] py-[40px] px-6 lg:px-0 flex flex-col gap-[40px] relative'>
            <div className='flex flex-col items-center gap-[10px] text-center'>
              <h1 className='text-white text-[24px] lg:text-[32px] font-semibold tracking-wide leading-[36px] uppercase'>Permanent Purchase options</h1>
              <p className='text-gray-600 text-[12px] lg:text-[16px] max-w-[500px]'>Your subscription includes this item via the Essentials Catalog! Purchase to own it permanently with unlimited downloads.</p>

              <NewExitIcon
                className="absolute right-[22px] top-[22px] md:right-8 md:top-8 cursor-pointer !stroke-[#F5F5F5] opacity-[50%] w-3 h-3 md:w-[18px] md:h-[18px] scale-125"
                onClick={onClose}
              />
            </div>

            <div className='lg:flex items-center justify-center gap-[34px]'>
              <PurchaseButton
                mode='purchase-options-modal'
                className="w-full h-[56px] lg:!max-w-[248px]"
                purchasedItem={collection}
                onPurchased={() => {
                  if (setCollection) setCollection({ ...collection, fully_purchased: true });
                  if (onClose) onClose();
                }}
                closePermanentPurchaseOptionModal={onClose}
                collectionId={collection.id}
              />
              <div className='text-gray-500 text-[16px] hidden lg:flex'>or</div>
              <div className='px-4 py-8 lg:hidden'>
                <DividerWithText />
              </div>
              <AddToCart collection={collection} mode='purchase-options-modal' closePermanentPurchaseOptionModal={onClose} />
            </div>

          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

export default PermanentPurchaseOptionsModal;
